module.exports = __webpack_public_path__ + "img/background-xl.a4bda3ae.jpg";